import { ref } from 'vue';

const skew = ref(0);

export function rememberServerTime(dateHeader: string | null | undefined): void {
  if (!dateHeader) {
    return;
  }

  const serverTime = Date.parse(dateHeader);

  if (Number.isNaN(serverTime)) {
    return;
  }

  skew.value = serverTime - Date.now();
}

export function serverNow(): number {
  return Date.now() + skew.value;
}

export function resetServerTime(): void {
  skew.value = 0;
}
